import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	manageCategoryLabel: {
		id: 'project-category.label-manage-categories',
		defaultMessage: 'Manage categories',
		description:
			'Manage categories link admins see in the projects category drop down of project details',
	},
});
